import { createAction, props } from "@ngrx/store";
import { Faq } from "../../models/Faq";

export const getAllFaqs = createAction(
  '[Faq] Get All Faqs'
);

export const getAllFaqsSuccess = createAction(
  '[Faq] Get All Faqs Success',
  props<{ faqs: Faq[] }>()
);

export const addFaq = createAction(
  '[Faq] Add Faq',
  props<{ faq: Faq }>()
);

export const addFaqSuccess = createAction(
  '[Faq] Add Faq Success',
  props<{ faq: Faq }>()
);

export const addFaqFailure = createAction(
  '[Faq] Add Faq Failure',
  props<{ error: any }>()
);

export const updateFaq = createAction(
  '[Faq] Update Faq',
  props<{ faq: Faq }>()
);

export const updateFaqSuccess = createAction(
  '[Faq] Update Faq Success',
  props<{ faq: Faq }>()
);

export const updateFaqFailure = createAction(
  '[Faq] Update Faq Failure',
  props<{ error: any }>()
);

export const deleteFaq = createAction(
  '[Faq] Delete Faq',
  props<{ id: number }>()
);

export const deleteFaqSuccess = createAction(
  '[Faq] Delete Faq Success',
  props<{ id: number }>()
);
